// extracted by mini-css-extract-plugin
export default {"hideScrollbar":"d70dcce3","deletableRow":"d7fe8f13","deleteAnswerButtonContainer":"bb68ed72","deleteAnswerButton":"e45687b2","deletedAnswer":"a84ccc70"};